<template>
	<v-container>
		<v-icon
			size="50"
			color="white"
		>
			fas fa-user-circle
		</v-icon>
		<v-form
			ref="form"
			lazy-validation
		>
			<v-layout 
				row 
				wrap
			>
				<v-flex 
					xs6
				>
					<v-text-field
						v-model="credentials.name"
						color="warning"
						:rules="[() => !!credentials.name || 'This field is required']"
						label="First name"
						required
					/>
				</v-flex>
				<v-flex 
					xs6
				>
					<v-text-field
						v-model="credentials.surname"
						color="warning"
						:rules="[() => !!credentials.surname || 'This field is required']"
						label="Last name"
						required
					/>
				</v-flex>
				<v-flex 
					xs12
				>
					<v-text-field
						v-model="credentials.phone"
						color="warning"
						:rules="[() => !!credentials.phone || 'This field is required']"
						label="Phone Number"
						required
					/>
				</v-flex>

				<v-flex 
					xs12
				>
					<v-text-field
						v-model="credentials.birth"
						color="warning"
						:rules="[() => !!credentials.birth || 'This field is required']"
						label="Date of Birth"
						type="date"
						required
					/>
				</v-flex>

				<v-flex 
					xs12
				>
					<v-text-field
						v-model="credentials.address"
						color="warning"
						:rules="[() => !!credentials.address || 'This field is required']"
						label="Address"
						type="address"
						required
					/>
				</v-flex>

				<v-flex 
					xs12
				>
					<v-autocomplete
						v-model="credentials.country"
						color="warning"
						:rules="[() => !!credentials.country || 'This field is required']"
						:items="countries"
						label="Country"
						placeholder="Select..."
						required
						append-icon="fas fa-arrow-circle-down"
						small
					/>
				</v-flex>
			</v-layout>
		</v-form>
	</v-container>
</template>


<script>
import { mapMutations, mapActions, mapGetters } from 'vuex'

export default {
	props: ['credentials'],

	data () {
		return {
			countries: ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Anguilla', 'Antigua &amp; Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bermuda', 'Bhutan', 'Bolivia', 'Bosnia &amp; Herzegovina', 'Botswana', 'Brazil', 'British Virgin Islands', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burundi', 'Cambodia', 'Cameroon', 'Cape Verde', 'Cayman Islands', 'Chad', 'Chile', 'China', 'Colombia', 'Congo', 'Cook Islands', 'Costa Rica', 'Cote D Ivoire', 'Croatia', 'Cruise Ship', 'Cuba', 'Cyprus', 'Czech Republic', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Estonia', 'Ethiopia', 'Falkland Islands', 'Faroe Islands', 'Fiji', 'Finland', 'France', 'French Polynesia', 'French West Indies', 'Gabon', 'Gambia', 'Georgia', 'Germany', 'Ghana', 'Gibraltar', 'Greece', 'Greenland', 'Grenada', 'Guam', 'Guatemala', 'Guernsey', 'Guinea', 'Guinea Bissau', 'Guyana', 'Haiti', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Isle of Man', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jersey', 'Jordan', 'Kazakhstan', 'Kenya', 'Kuwait', 'Kyrgyz Republic', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Mauritania', 'Mauritius', 'Mexico', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Montserrat', 'Morocco', 'Mozambique', 'Namibia', 'Nepal', 'Netherlands', 'Netherlands Antilles', 'New Caledonia', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'Norway', 'Oman', 'Pakistan', 'Palestine', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Puerto Rico', 'Qatar', 'Reunion', 'Romania', 'Russia', 'Rwanda', 'Saint Pierre &amp; Miquelon', 'Samoa', 'San Marino', 'Satellite', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Slovakia', 'Slovenia', 'South Africa', 'South Korea', 'Spain', 'Sri Lanka', 'St Kitts &amp; Nevis', 'St Lucia', 'St Vincent', 'St. Lucia', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor L\'Este', 'Togo', 'Tonga', 'Trinidad &amp; Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Turks &amp; Caicos', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Venezuela', 'Vietnam', 'Virgin Islands (US)', 'Yemen', 'Zambia', 'Zimbabwe'],
			alertLabel: '',
		}
	},

	computed: {

	},

	watch: {
	
	},

	methods: {

	},

}
</script>

<style lang="scss" scoped>
@import '@/styles/index.scss';

.title {
	color: $primary !important;
	text-transform: uppercase;
	font-size: 22px !important;
	font-weight: 400;
	margin: 10%;
}

.login-field {
	border-radius: 100px;
}

.sign-button {
	color: $primary;
	margin-left: 1%;
	font-size: 16px;
	text-transform: uppercase;
}

.sign-button:hover {
	text-decoration: underline;
}

.sign-disclaimer {
	font-size: 16px;
	color: rgba(0, 0, 0, 0.8);

}

.sign-in-container {
	margin-top: 5% !important;
}

</style>
